<template>
  <div>
    <header-bar>YouTubeマネタイズ</header-bar>
    <div>
      <div class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">手動申し立て</h3>
        </div>
        <div
          v-if="!completed"
          class="page-block__inner">
          <div>
            <video-table
              :video="video" />
          </div>

          <div
            class="my-release-list"
            style="min-height: 340px">
            <div
              class="youtube-detail-box">
              <div class="video-player-control">
                <youtube
                  ref="youtube"
                  width="500"
                  fit-parent
                  name="claimPreview"
                  :video-id="videoId"
                  :player-vars="playerVars">
                </youtube>
                <div style="display: flex; width: 500px">
                  <div
                    style="width: 250px; text-align: center">
                    <a
                      href="#"
                      class="c-btn--text"
                      @click.prevent="setStartTime">
                      開始時間を設定
                    </a>
                  </div>
                  <div
                    style="width: 250px; text-align: center">
                    <a
                      href="#"
                      class="c-btn--text"
                      @click.prevent="setEndTime">
                      終了時間を設定
                    </a>
                  </div>
                </div>
              </div>
              <div style="width: 650px">
                <div style="display: flex">
                  <div
                    v-if="asset.id"
                    style="font-size: 14px;">
                    <div style="font-weight: bold">{{ asset.metadata.title }}</div>
                    <div style="color: gray">({{ asset.metadata.isrc }})</div>
                  </div>
                  <div style="margin-left: auto;">
                    <a
                      v-if="asset.id"
                      href="#"
                      class="c-btn--text"
                      style="width: 220px;margin-left: auto;"
                      @click.prevent="assetDialogShow = true">
                      アセット変更
                    </a>
                    <a
                      v-else
                      href="#"
                      class="c-btn--narrow c-btn"
                      style="width: 250px"
                      @click.prevent="assetDialogShow = true">
                      アセット選択
                    </a>
                  </div>
                </div>

                <div
                  v-if="asset.id"
                  style="margin-top: 20px;">
                  <div
                    v-for="(segment, index) in matchSegments"
                    :key="index"
                    :class="{
                      'segment-focus': index === currentSegmentIndex,
                    }"
                    style="display: flex;border: 3px solid transparent"
                    @click.prevent="currentSegmentIndex = index">
                    <div style="padding: 30px 8px;font-weight: bold">
                      {{ index + 1 }}.
                    </div>
                    <div>
                      <div style="font-size: 14px;">開始時間</div>
                      <div style="font-size: 14px;">
                        <input
                          v-model="segment.start"
                          type="time"
                          class="form-control flash-area"
                          :style="{
                            backgroundColor: targetIdentifier === `start-${index}`
                              ? '#ef9700' : 'white',
                          }"
                          step="0.001" />
                      </div>
                    </div>
                    <div style="padding-left: 12px">
                      <div style="font-size: 14px;">終了時間</div>
                      <div style="font-size: 14px;">
                        <input
                          v-model="segment.end"
                          type="time"
                          class="form-control flash-area"
                          :style="{
                            backgroundColor: targetIdentifier === `end-${index}`
                              ? '#ef9700' : 'white',
                          }"
                          step="0.001" />
                      </div>
                    </div>
                    <div style="padding: 25px 20px">
                      <a
                        v-if="matchSegments.length > 1"
                        href="#"
                        class="c-btn--text"
                        @click.stop="removeSegment(index)">
                        削除
                      </a>
                    </div>
                  </div>
                  <div style="text-align: right">
                    <a
                      href="#"
                      class="c-btn--text"
                      @click.prevent="addSegment">
                      セグメントを追加する
                    </a>
                  </div>
                </div>

                <div
                  v-show="false"
                  style="margin-top: 20px;">
                  <div style="font-size: 14px;">申し立てタイプ</div>
                  <select
                    v-model="contentType"
                    disabled
                    class="form-control">
                    <option
                      v-for="c in contentTypes"
                      :key="c.value"
                      :value="c.value">
                      {{ c.name }}
                    </option>
                  </select>
                </div>

                <div
                  v-show="false"
                  style="margin-top: 20px;">
                  <div style="font-size: 14px;">ポリシー</div>
                  <select
                    v-model="policy"
                    disabled
                    class="form-control">
                    <option
                      v-for="p in policies"
                      :key="p.id"
                      :value="p.id">
                      {{ p.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <p
              v-if="errorMessage"
              class="error-text">
              {{ errorMessage }}
            </p>
            <div
              class="page-block__request">
              <a
                class="c-btn c-btn--edit"
                href="#"
                @click.prevent="onRequestClicked">
                申し立てを有効にする
                <span class="c-btn--delivery c-btn__icon-arrow--right"></span>
              </a>
              <a
                v-if="false"
                class="c-btn c-btn--edit"
                href="#"
                @click.prevent="onRejectClicked">
                申し立てを取り下げる
                <span class="c-btn--delivery c-btn__icon-arrow--right"></span>
              </a>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="page-block__inner">
            <div class="form-complete-area">
              <div class="form-complete-area__title">手動申し立て受付完了</div>
              <div class="form-complete-area__lead">「{{ video.title }}」への手動申し立てを受け付けました。</div>
              <div class="c-btn-wrap">
                <a
                  class="c-btn c-btn--back"
                  href="#"
                  @click.prevent="back">
                  戻る
                  <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="page-block__inner">
          <a
            v-if="!completed"
            class="c-btn c-btn--back"
            href="#"
            @click.prevent="back">
            戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </a>
        </div>
      </div>
    </div>
    <asset-dialog
      :is-shown="assetDialogShow"
      :video-id="videoId"
      @row-clicked="onAssetSelected"
      @closed="onDialogClosed" />
  </div>
</template>

<script>
import HeaderBar from '../../../HeaderBar'
import YouTubeClaimsVideoTable from './VideoTable'
import YouTubeAssetsDialog from '../../Assets/Dialog'

export default {
  name: 'YouTubeClaimsRequestForm',
  components: {
    HeaderBar,
    VideoTable: YouTubeClaimsVideoTable,
    AssetDialog: YouTubeAssetsDialog,
  },
  props: {
    videoId: {
      type: String,
      required: false,
      default: '',
    },
    playerVars: {
      type: Object,
      default: () => ({
        autoplay: 0,
        controls: 1,
      }),
    },
    contentTypes: {
      type: Array,
      default: () => [
        { name: '音声', value: 'audio' },
        { name: '動画', value: 'audiovisual' },
      ],
    },
  },
  data() {
    return {
      video: {},
      assetId: null,
      asset: {},
      error: null,
      errorMessage: null,
      assetDialogShow: false,
      playing: false,
      currentSegmentIndex: 0,
      matchSegments: [
        { start: '00:00:00.000', end: '00:00:00.000' },
      ],
      targetIdentifier: null,
      policy: {},
      policies: [],
      contentType: 'audio',
      completed: false,
      claim: null,
    }
  },
  watch: {
    videoId(value) {
      this.fetchItems(value, true)
    },
  },
  mounted() {
    if (this.$route.query.asset_id) {
      this.assetId = this.$route.query.asset_id
      this.fetchAsset()
    }
    this.fetchItems(this.videoId)
    this.fetchPolicies()
  },
  methods: {
    async fetchItems(videoId, reload = false) {
      this.errorMessage = null
      this.video = {}
      this.modalVideoId = null
      this.error = null
      if (reload) {
        // URL に履歴を残す
        const query = this.modalVideoId
          ? { video_id: videoId, modal_video_id: this.modalVideoId }
          : { video_id: videoId }
        this.$router.replace({ name: 'youtube-claims-request-form', query })
      }
      try {
        // 検索結果を取得
        const { data } = await window.axios.get(`/api/client/youtube/claims/video/${videoId}`)
        this.video = data.video
      } catch (e) {
        const { response } = e
        const { status } = response
        if (status === 404) {
          this.claims = []
          this.errorMessage = '検索結果が見つかりませんでした'
        }
        this.error = e
      }
    },
    async fetchAsset() {
      if (!this.assetId) {
        return
      }
      const { data } = await window.axios.get(`/api/client/youtube/assets/${this.assetId}?video_id=${this.videoId}`)
      const { asset, claim } = data
      this.asset = asset
      const { matchPolicy } = this.asset
      if (matchPolicy) {
        this.policy = matchPolicy.policyId
      }
      this.claim = claim
      if (this.claim) {
        this.policy = this.claim.policy.id
        const { matchSegments } = this.claim.matchInfo
        this.matchSegments = matchSegments.map((segment) => {
          const { video_segment: videoSegment } = segment
          return {
            start: this.formatMilliseconds(videoSegment.start),
            end: this.formatMilliseconds(
              parseInt(videoSegment.start, 10)
              + parseInt(videoSegment.duration, 10),
            ),
          }
        })
      }
    },
    async fetchPolicies() {
      const { data } = await window.axios.get('/api/client/youtube/policies')
      this.policies = data
    },
    back() {
      this.$router.push({
        name: 'youtube-claims-request-index',
      })
    },
    onAssetSelected(assetId) {
      const query = { asset_id: assetId }
      this.$router.replace({ name: 'youtube-claims-request-form', query })

      this.assetDialogShow = false
      this.assetId = assetId
      this.fetchAsset()
    },
    onDialogClosed() {
      this.assetDialogShow = false
    },
    setStartTime() {
      this.$refs.youtube.player.getCurrentTime().then((time) => {
        const msec = Math.round(time * 1000)
        this.matchSegments[this.currentSegmentIndex].start = this.formatMilliseconds(msec)
        this.targetIdentifier = `start-${this.currentSegmentIndex}`
        setTimeout(() => {
          this.targetIdentifier = null
        }, 500)
      })
    },
    setEndTime() {
      this.$refs.youtube.player.getCurrentTime().then((time) => {
        const msec = Math.round(time * 1000)
        this.matchSegments[this.currentSegmentIndex].end = this.formatMilliseconds(msec)

        this.targetIdentifier = `end-${this.currentSegmentIndex}`
        setTimeout(() => {
          this.targetIdentifier = null
        }, 500)
      })
    },
    async setLastEndTime() {
      const time = await this.$refs.youtube.player.getDuration()
      const msec = Math.round(time * 1000)
      this.matchSegments[this.currentSegmentIndex].end = this.formatMilliseconds(msec)

      this.targetIdentifier = `end-${this.currentSegmentIndex}`
      setTimeout(() => {
        this.targetIdentifier = null
      }, 500)
    },
    addSegment() {
      this.matchSegments.push({ start: '00:00:00.000', end: '00:00:00.000' })
      this.currentSegmentIndex = this.matchSegments.length - 1
    },
    removeSegment(index) {
      this.$delete(this.matchSegments, index)
      if (this.currentSegmentIndex > 0) {
        this.currentSegmentIndex -= 1
      }
    },
    formatMilliseconds(milliseconds) {
      let remainingMilliseconds = milliseconds

      // ミリ秒から時間、分、秒、ミリ秒を計算
      const hours = Math.floor(remainingMilliseconds / 3600000)
      remainingMilliseconds %= 3600000
      const minutes = Math.floor(remainingMilliseconds / 60000)
      remainingMilliseconds %= 60000
      const seconds = Math.floor(remainingMilliseconds / 1000)
      const millis = remainingMilliseconds % 1000

      // 各値を 2 桁または 3 桁にフォーマット
      const formattedHours = String(hours).padStart(2, '0')
      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(seconds).padStart(2, '0')
      const formattedMillis = String(millis).padStart(3, '0')

      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}.${formattedMillis}`
    },
    async onRequestClicked() {
      const params = {
        video_id: this.videoId,
        asset_id: this.assetId,
        policy_id: this.policy,
        segments: this.matchSegments,
        content_type: this.contentType,
      }
      try {
        const { data } = await window.axios.post('/api/client/youtube/claims', params)
        this.completed = data.message === 'success'
      } catch (e) {
        this.errorMessage = e.message
        this.completed = false
      }
    },
    async onRejectClicked() {
      const params = {
        video_id: this.videoId,
        asset_id: this.assetId,
        policy_id: this.policy,
        segments: this.matchSegments,
        content_type: this.contentType,
      }
      try {
        const { data } = await window.axios.put(`/api/client/youtube/claims/${this.claim.id}`, params)
        this.completed = data.message === 'success'
      } catch (e) {
        this.errorMessage = e.message
        this.completed = false
      }
    },
  },
}
</script>

<style scoped>
.segment-focus {
  background-color: #ecd48a;
  border: 3px solid #dc6d6d!important;
}
.flash-area {
  background-color: white; /* デフォルトの背景色 */
  transition: background-color 0.5s linear; /* 1秒かけて背景色を変化させる */
}
.page-block__request {
  margin-top: 20px;
  text-align: center;
}
.video-player-control {
  margin-right: 20px;
  padding: 0 0 8px;
  border: 2px solid #404040;
  background-color: #ffffff;
}
</style>
